/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// uploadPdfAndImage
// UPLOADPDFANDIMAGE
const GETINTERNSHIPBYID= createAsyncThunk(
  "getInternshipById/getInternshipById",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getInternshipByIdSlice = createSlice({
  name: "getInternshipByIdSlice",
  initialState: {
    getInternshipById: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetInternshipById: (state) => {
        state.getInternshipById.loading = false
        state.getInternshipById.error = false
        state.getInternshipById.data = []
        state.getInternshipById.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETINTERNSHIPBYID.fulfilled, (state, action) => {
      state.getInternshipById = {
        ...state.getInternshipById,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETINTERNSHIPBYID.pending, (state, action) => {
      state.getInternshipById = {
        ...state.getInternshipById,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETINTERNSHIPBYID.rejected, (state, action) => {
      state.getInternshipById = {
        ...state.getInternshipById,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getInternshipByIdAction = {
    GETINTERNSHIPBYID,
};

export { getInternshipByIdAction };
export default getInternshipByIdSlice.reducer;
export const {setInitialStateOfgetInternshipById} = getInternshipByIdSlice.actions